import { render, staticRenderFns } from "./PartRight.vue?vue&type=template&id=98caa3a8&scoped=true"
import script from "./PartRight.vue?vue&type=script&lang=js"
export * from "./PartRight.vue?vue&type=script&lang=js"
import style0 from "./PartRight.vue?vue&type=style&index=0&id=98caa3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98caa3a8",
  null
  
)

export default component.exports